// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.portal_CTW3h {
  position : absolute;
  top : 0;
  bottom : 0;
  left : 0;
  right : 0;
  overflow : hidden;
  pointer-events: none;
  z-index: 100;
}

.portal_CTW3h > * {
  pointer-events: initial;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/Portal.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["\n.portal {\n  position : absolute;\n  top : 0;\n  bottom : 0;\n  left : 0;\n  right : 0;\n  overflow : hidden;\n  pointer-events: none;\n  z-index: 100;\n}\n\n.portal > * {\n  pointer-events: initial;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"portal": `portal_CTW3h`
};
export default ___CSS_LOADER_EXPORT___;
